<template>
  <!-- tab 1-->
  <v-tab-item key="1">
    <v-card flat tile class="px-6">
      <v-row align="center" justify="center">
        <v-col md="3" class="py-0">
          <span>Full name:</span>
        </v-col>
        <v-col md="9" class="py-0">
          <span class="font-weight-bold"
            >{{ userDetails.firstName }}&nbsp;{{
              userDetails.middleName
            }}&nbsp;{{ userDetails.lastName }}</span
          >
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col md="3">
          <span>Roles:</span>
        </v-col>
        <v-col md="9">
          <div
            class="list-container"
            v-if="roleSelectedList && roleSelectedList.length > 0"
          >
            <tag
              v-for="item in roleSelectedList"
              :key="item.id"
              :text="item.val"
              data-class="dynamicTagsdark"
              :showDelete="false"
            ></tag>
          </div>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col md="3">
          <span>Primary email address:</span>
        </v-col>
        <v-col md="9">
          <span class="font-weight-bold">{{ userDetails.primaryEmail }}</span>
          <!-- <v-text-field
                      label="firstname.lastname@xift.com"
                      solo
                      filled
                      flat
                      height="52px"
                      background-color="#E5E5E5 !important"
                      v-model=""
                    ></v-text-field>-->
        </v-col>
      </v-row>
      <div v-if="emailAlias">
        <v-row align="center" v-for="item in emailAlias" :key="item.id">
          <v-col md="3">
            <span>{{ item.label }}</span>
          </v-col>
          <v-col md="7">
            <span class="font-weight-bold">{{ item.val }}</span>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <v-row align="center">
          <v-col md="3">
            <span>Email aliases</span>
          </v-col>
          <v-col md="7">
            <span class="font-weight-bold">Not provided</span>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-tab-item>
  <!-- tab 1-->
</template>
<script>
export default {
  data() {
    return {
      emailAlias: [],
      counter: 0,
      roleSelectedList: [],
    };
  },
  props: ['userDetails'],
  mounted() {
    this.setAliases();
    this.getRoles();
  },
  methods: {
    // set secondary email aliases
    setAliases() {
      let aliases = [];
      if (this.userDetails.secondaryEmails.length) {
        for (
          let index = 0;
          index < this.userDetails.secondaryEmails.length;
          index++
        ) {
          aliases.push({
            id: 'alias' + ++this.counter,
            val: this.userDetails.secondaryEmails[index],
            label: 'Email aliases:',
          });
        }
        this.emailAlias = aliases;
      }
    },
    getRoles() {
      this.roleSelectedList = this.userDetails.roles.map((ele) => ({
        id: ele,
        val: ele,
      }));
      this.roleSelectedList = this.removeUnderscore(this.roleSelectedList);
    },
  },
};
</script>
